import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 11.066L4.96657 8.03343L5.57343 7.41629L7.57143 9.41429V2H8.42857V9.41429L10.4257 7.41714L11.0334 8.03343L8 11.066ZM2 14V10.5389H2.85714V13.1429H13.1429V10.5389H14V14H2Z", fill: "#727272" }));
const ForwardRef = forwardRef(SvgDownloadIcon);
export { ForwardRef as ReactComponent };
